<footer class="ui-form-action-footer">
  <div class="ui-form-action-footer__left">
    @if (showBack()) {
      <ui-button variant="secondary" [disabled]="disableBack()" (click)="onBackClicked()">{{ backLabel() }}</ui-button>
    }
  </div>

  <div class="ui-form-action-footer__right">
    @if (showSave()) {
      <ui-button [disabled]="disableSave() || isSaving()" (click)="onSaveClicked()">{{ saveLabel() }}</ui-button>
    }
    @if (showNext()) {
      <ui-button variant="secondary" [disabled]="disableNext()" (click)="onNextClicked()">{{ nextLabel() }}</ui-button>
    }
  </div>
</footer>
